/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSocietyFormTaskUser
 */
export interface AdminSocietyFormTaskUser {
    /**
     * 
     * @type {number}
     * @memberof AdminSocietyFormTaskUser
     */
    readonly id?: number;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof AdminSocietyFormTaskUser
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSocietyFormTaskUser
     */
    readonly fullName?: string;
}

/**
 * Check if a given object implements the AdminSocietyFormTaskUser interface.
 */
export function instanceOfAdminSocietyFormTaskUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function AdminSocietyFormTaskUserFromJSON(json: any): AdminSocietyFormTaskUser {
    return AdminSocietyFormTaskUserFromJSONTyped(json, false);
}

export function AdminSocietyFormTaskUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSocietyFormTaskUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': json['username'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
    };
}

export function AdminSocietyFormTaskUserToJSON(value?: AdminSocietyFormTaskUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
    };
}

